import { CalendarIcon, ZapIcon, TargetIcon, GamepadIcon, SmartphoneIcon, type LucideIcon } from 'lucide-react';

export interface Bonus {
  icon: LucideIcon;
  emoji: string;
  title: string;
  value: string;
  text: string;
}

export const bonuses: Bonus[] = [
  {
    icon: CalendarIcon,
    emoji: '🗓️',
    title: 'Plan de Arranque 7 Días',
    value: '9,90€',
    text: 'La hoja de ruta exacta para aplicar MISTER PRO desde el primer día sin perderte entre 400 páginas. Diagnóstico del equipo, sistema de juego, primera sesión lista y primer mensaje a padres en solo 7 días.'
  },
  {
    icon: ZapIcon,
    emoji: '⚡',
    title: 'Sesión Express 15 Minutos',
    value: '12,90€',
    text: 'Tu botón de emergencia como entrenador. Cuando salgas tarde del trabajo y todavía no hayas preparado el entrenamiento del martes, abres este bono y en 15 minutos tienes una sesión profesional lista. Incluye 20 condiciones de partido listas para usar.'
  },
  {
    icon: TargetIcon,
    emoji: '🎯',
    title: '30 Entrenamientos Listos para Pitar',
    value: '14,90€',
    text: '30 sesiones completas organizadas por objetivo: técnica, táctica, físico con balón, finalización y balón parado. Cada una con tiempos exactos, correcciones clave y adaptación para pocos jugadores o medio campo. El recurso más consultado por los entrenadores que ya tienen el sistema.'
  },
  {
    icon: GamepadIcon,
    emoji: '⚽',
    title: '30 Juegos Técnicos para Fútbol Base',
    value: '11,90€',
    text: '30 juegos competitivos para mejorar control, pase, conducción, regate y finalización sin que parezca un ejercicio aburrido. Cuando hay algo en juego, la intensidad y el aprendizaje se multiplican. Adaptados desde Benjamín hasta Cadete.'
  },
  {
    icon: SmartphoneIcon,
    emoji: '📱',
    title: 'Mapa de Temporada en una Página',
    value: '9,90€',
    text: 'Una sola hoja con toda la temporada planificada. Qué foco trabajar cada mes, qué tomo consultar y cómo medir si el equipo ha mejorado. Versión Fútbol 7 y versión Fútbol 11. Imprimible y plastificable para llevar siempre en tu carpeta.'
  }
];
